import { forwardRef } from "react";
import { useInput, Validator } from "react-admin";

import { Choice } from "types";

import { SelectManyField } from "./SelectManyField";

interface Props {
  source: string;
  label?: string;
  choices: Choice[];
  placeholder?: string;
  helperText?: string;
  disabled?: boolean;
  validate?: Validator | Validator[];
}

export const SelectManyFieldWrapper = forwardRef(({ source, validate, ...props }: Props, ref) => {
  const { id, field, fieldState } = useInput({ id: source, source, validate, defaultValue: [] });

  return <SelectManyField {...props} {...field} id={id} fieldState={fieldState} ref={ref} />;
});
